import { getField, updateField } from "vuex-map-fields";

import _ from "lodash";

export default {
  namespaced: true,

  state: {
    invoice: null
  },

  getters: {
    getField,

    lineItems (state) {
      return state.invoice.line_items;
    },

    invoiceCurrency (state) {
      return state.invoice.currency;
    },

    discount (state) {
      return state.invoice.discount;
    },

    discountExists (state) {
      return state.invoice.discount !== null;
    },

    invoiceSubtotal (state) {
      return state.invoice.invoice_subtotal;
    },

    invoiceTotal (state) {
      return state.invoice.total;
    },

    summaryTaxes (_state, getters) {
      return _.compact(_.uniqBy(_.map(getters.lineItems, "tax"), "id"));
    },

    taxAmount: (state, getters) => (tax) => {
      return getters.lineItems.reduce(
        (result, lineItem) => result + (
          (lineItem.tax_id === tax.id)
            ? lineItem.tax_amount : 0), 0);
    },

    taxName: (state, getters) => (tax) => {
      return getters.lineItems.find(lineItem => lineItem.tax.id === tax.id).tax.name.toUpperCase();
    },

    taxRate: (state, getters) => (tax) => {
      return getters.lineItems.find(lineItem => lineItem.tax.id === tax.id).tax.rate;
    }
  },

  mutations: {
    updateField,

    updateInvoice (state, invoice) {
      state.invoice = invoice;
    }
  },

  actions: {
  }
};
